<template>

    <section>

         <div style="text-align:center; padding-top:20px;">
                    <router-link class="btn color-1" to="/manufacturers"> Manufacturers </router-link>
                    <router-link class="btn color-1" to="/distributors"> Distributors </router-link>
                    <router-link class="btn color-1" to="/retailers"> Retailers </router-link>
                </div>

        <div style="text-align:center; padding-top:50px;">
            <p style="color: grey;">© 2026 Trueleey.com - All rights reserved</p>
        </div>
    </section>

</template>
